// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminRolesForm-errorMessage-_kH0G {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.AdminRolesForm-commonHeaderAdmin-CXn_V {
	position: fixed !important;
}
.AdminRolesForm-adminLayout-i3g5L {
	padding-top: 64px !important;
}
.AdminRolesForm-box-lgyMl h2 {
	font-size: 21px;
	font-weight: 600;
}
.AdminRolesForm-exportLink-mgPgV {
	margin-bottom: -29px;
}
.AdminRolesForm-blockCenter-Cg83d {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}
.AdminRolesForm-panelHeader-CW6U4 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}
.AdminRolesForm-currencyselect-dxVJ6 {
	width: 100%;
	margin-right: 0px;
}
.AdminRolesForm-panelHeader-CW6U4 {
	overflow: hidden;
	position: relative;
}
.AdminRolesForm-mar0-Qm6Lq {
	margin-left: 0;
	margin-right: 0;
}
@media screen and (max-width: 767px) {
	.AdminRolesForm-blockCenter-Cg83d {
		padding: 0px;
	}

	.AdminRolesForm-panelHeader-CW6U4 {
		padding: 24px 5px;
	}
}
/** Admin - Common - Start **/
.AdminRolesForm-sideAdminPageWrapper-AiDox {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}
.AdminRolesForm-panelHeader-CW6U4 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}
.AdminRolesForm-table-XywGE {
	display: table;
}
.AdminRolesForm-tableRow-OAlpN {
	display: table-row;
}
.AdminRolesForm-tableCell-Gu33H {
	display: table-cell;
	float: none;
}
.AdminRolesForm-formGroup-tsCP8 {
	margin-bottom: 6px;
}
.AdminRolesForm-select-mixRo {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}
.AdminRolesForm-noMargin-_JC8J {
	margin: 0px;
}
a,
a:hover {
	cursor: pointer;
}
.AdminRolesForm-exportLink-mgPgV {
	padding-top: 10px;
	padding-right: 10px;
}
.AdminRolesForm-labelTextNew-pahRo {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}
.AdminRolesForm-displayInline-sr3K2 {
	display: inline-block;
}
/******************* Admin Modal ListSetting Start *******************/
.AdminRolesForm-btnUPdate-PFAeu {
	display: inline-block;
}
.AdminRolesForm-btnModalDelete-_OZbG {
	display: inline-block;
	margin-left: 15px;
}
.AdminRolesForm-radioBtn-lJOFc {
	position: relative;
	top: 1px;
	vertical-align: middle;
}
.AdminRolesForm-backgroundImg-e3OE3 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}
@media screen and (max-width: 767px) {
	.AdminRolesForm-btnUPdate-PFAeu {
		display: block;
		margin-bottom: 12px;
	}

	.AdminRolesForm-btnModalDelete-_OZbG {
		display: block;
		margin-left: 0px;
	}

	.AdminRolesForm-btnWidth-MmVfa {
		width: 100%;
	}
}
/******************* Admin Modal ListSetting Start *******************/
/******************* Admin Banner Image Section Start ****************/
.AdminRolesForm-bannerImageBg-ZfS80 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}
.AdminRolesForm-bannerDelete-zs2nR {
	position: absolute;
	top: -12px;
	right: 4px;
}
/*******************Admin Modal Start **********************/
.AdminRolesForm-modalRoot-tKQnr {
	padding: 32px;
}
.AdminRolesForm-modalBorderBottom-Rlp2U {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}
.AdminRolesForm-logInModalBody-Q5Oqo {
	padding: 0px;
}
/*************** Admin TableNew Design Start**************************/
.AdminRolesForm-exportSection-g6lcY {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}
.AdminRolesForm-exportSectionGridSub-ZKoJO {
	grid-template-columns: 50% 49% !important;
}
.AdminRolesForm-exportText-aswuP {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}
.AdminRolesForm-exportLinkImg-nQsax {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}
.AdminRolesForm-vtrMiddle-RSYzP {
	vertical-align: middle;
}
.AdminRolesForm-exportImg-ldAmh {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}
.AdminRolesForm-profileViewlabel-PdmIQ {
	display: inline-block;
	width: 38%
}
.AdminRolesForm-profileViewMainContent-_zK81 {
	display: inline-block;
	width: 62%;
}
.AdminRolesForm-profileViewMain-f2BzD {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.AdminRolesForm-profileViewInner-cmtoa {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}
.AdminRolesForm-profileImageSection-dSzgt {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}
.AdminRolesForm-lastviewInner-Jxrif {
	padding: 10px;
}
.AdminRolesForm-whyHostHoriLine-n6Uzg {
	margin: 30px 0;
}
.AdminRolesForm-tableGrid-ydJ7f {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}
.AdminRolesForm-headingContent-feswr {
	font-size: 18px;
	font-weight: 500;
}
.AdminRolesForm-refundTextColor-tE6aV {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}
.AdminRolesForm-dividerLine-BeDf1 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}
.AdminRolesForm-smallContent-nsCJz {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}
@media (max-width: 1200px) and (min-width: 1024px) {
	.AdminRolesForm-sideAdminPageWrapper-AiDox {
		height: 100%;
		overflow: auto;
	}
}
@media (max-width:1199px) {
	.AdminRolesForm-sideAdminPageWrapper-AiDox {
		margin-left: 0;
	}
}
@media screen and (max-width: 991px) {
	.AdminRolesForm-exportSection-g6lcY {
		grid-template-columns: 100%;
	}

	.AdminRolesForm-exportSectionGridSub-ZKoJO {
		grid-template-columns: 100% !important;
	}

}
@media screen and (max-width: 767px) {
	.AdminRolesForm-profileViewlabel-PdmIQ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminRolesForm-profileViewMainContent-_zK81 {
		width: 100%;
		text-align: center;
	}
}
/*************** Admin TableNew Design End**************************/
.AdminRolesForm-ChangeToUpperCase-l2brT {
	text-transform: uppercase
}
.AdminRolesForm-noBorder-tCaV5 {
	border: 0px !important;
}
/** Admin - Common - End **/
/* site Admin utility Start */
.AdminRolesForm-siteAdminHeading-H2RVf {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}
.AdminRolesForm-siteAdminSubHeading-j4TI7 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}
.AdminRolesForm-adminFormDivider-FqTcn {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}
.AdminRolesForm-space1-odANP {
	margin-bottom: 6px !important;
}
.AdminRolesForm-space2-oySC9 {
	margin-bottom: 12px !important;
}
.AdminRolesForm-space3-njpai {
	margin-bottom: 18px !important;
}
.AdminRolesForm-space4-WCBjd {
	margin-bottom: 24px !important;
}
.AdminRolesForm-space5-Qi7w7 {
	margin-bottom: 30px !important;
}
.AdminRolesForm-space6-nRGyZ {
	margin-bottom: 36px !important;
}
.AdminRolesForm-space7-o0NOL {
	margin-bottom: 42px !important;
}
.AdminRolesForm-spaceTop8-WPbH7 {
	margin-bottom: 48px !important;
}
.AdminRolesForm-spaceTop1-o0z6i {
	margin-top: 6px !important;
}
.AdminRolesForm-spaceTop2-Gef36 {
	margin-top: 12px !important;
}
.AdminRolesForm-spaceTop3-xCIpA {
	margin-top: 18px !important;
}
.AdminRolesForm-spaceTop4-MueSN {
	margin-top: 24px !important;
}
.AdminRolesForm-spaceTop5-aoeyp {
	margin-top: 30px !important;
}
.AdminRolesForm-spaceTop6-zVrJc {
	margin-top: 36px !important;
}
.AdminRolesForm-spaceTop7-Ahr9R {
	margin-top: 42px !important;
}
.AdminRolesForm-spaceTop8-WPbH7 {
	margin-top: 48px !important;
}
.AdminRolesForm-noMargin-_JC8J {
	margin: 0px !important;
}
.AdminRolesForm-padding1-BPtvh {
	padding-bottom: 6px !important;
}
.AdminRolesForm-padding2-pWgKl {
	padding-bottom: 12px !important;
}
.AdminRolesForm-padding3-qwu6D {
	padding-bottom: 18px !important;
}
.AdminRolesForm-padding4-A4gyN {
	padding-bottom: 24px !important;
}
.AdminRolesForm-padding5-Czo9p {
	padding-bottom: 30px !important;
}
.AdminRolesForm-padding6-cwGag {
	padding-bottom: 36px !important;
}
.AdminRolesForm-padding7-gAkCf {
	padding-bottom: 42px !important;
}
.AdminRolesForm-paddingTop1-msHCg {
	padding-top: 6px !important;
}
.AdminRolesForm-paddingTop2-o_xMX {
	padding-top: 12px !important;
}
.AdminRolesForm-paddingTop3-YD2Vk {
	padding-top: 18px !important;
}
.AdminRolesForm-paddingTop4-QhB_1 {
	padding-top: 24px !important;
}
.AdminRolesForm-paddingTop5-elgGl {
	padding-top: 30px !important;
}
.AdminRolesForm-paddingTop6-VPH_M {
	padding-top: 36px !important;
}
.AdminRolesForm-paddingTop7-dWFzG {
	padding-top: 42px !important;
}
.AdminRolesForm-noPadding-pupcj {
	padding: 0px !important;
}
.AdminRolesForm-textBold-tJvuQ {
	font-weight: 500 !important;
}
.AdminRolesForm-textBolder-tHj06 {
	font-weight: 700 !important;
}
.AdminRolesForm-textNormal-MvpIT {
	font-weight: normal !important;
}
.AdminRolesForm-spaceBottom20-yaWjZ {
	margin-bottom: 20px;
}
.AdminRolesForm-spaceBottom10-CuBfY {
	margin-bottom: 10px;
}
.AdminRolesForm-marginNone-UHFAV {
	margin: 0;
}
.AdminRolesForm-spaceBottom15-Eu48t {
	margin-bottom: 15px;
}
.AdminRolesForm-marginTopNone-yGm1t {
	margin-top: 0;
}
.AdminRolesForm-spaceTop11-wTmon {
	margin-top: 11px;
}
.AdminRolesForm-spaceTop21-mrO6d {
	margin-top: 21px;
}
.AdminRolesForm-spaceTop20-L21Hw {
	margin-top: 20px;
}
.AdminRolesForm-spaceTop10-LR0lW {
	margin-top: 10px;
}
/*New Design Text Colors */
.AdminRolesForm-textDarkBlue-l7Rhp {
	color: rgb(20, 39, 94) !important;
}
.AdminRolesForm-textLightBlue-l4MYh {
	color: rgb(57, 87, 106) !important;
}
.AdminRolesForm-textLightSandleGreen-Lzojr {
	color: rgb(76, 86, 41) !important;
}
.AdminRolesForm-textLightBrown-UEKIR {
	color: rgb(115, 79, 33) !important;
}
.AdminRolesForm-textMediumMaroon-kslNL {
	color: rgb(87, 37, 51) !important;
}
.AdminRolesForm-textBrown-m0AJq {
	color: rgb(160, 47, 24) !important;
}
.AdminRolesForm-textMaroon-nQMvm {
	color: rgb(155, 49, 67) !important;
}
.AdminRolesForm-textDarkBrown-ERPRG {
	color: rgb(83, 18, 16) !important;
}
.AdminRolesForm-textMediumBrown-GOLdl {
	color: rgb(142, 28, 10) !important;
}
.AdminRolesForm-textSkyBlue-ADv8s {
	color: rgb(37, 117, 141) !important;
}
.AdminRolesForm-textGray-LapmR {
	color: rgb(77, 65, 51) !important;
}
/** RentAll - Begin **/
.AdminRolesForm-checkBoxWidth-e425Q {
  width: 34px;
}
.AdminRolesForm-textWidth-nSu7O {
  width: 88%;
  vertical-align: middle;
  font-size: 16px;
}
.AdminRolesForm-labelFontWeightNormal-fYSRC {
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/AdminRolesForm/AdminRolesForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,0BAA0B;AAC3B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,cAAc;CACd,eAAe;AAChB;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;ACpDA,6BAA6B;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;AAEA;CACC,cAAc;AACf;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,WAAW;AACZ;AAEA;;CAEC,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,qBAAqB;AACtB;AAEA,sEAAsE;AAEtE;CACC,qBAAqB;AACtB;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;AAEA,sEAAsE;AAEtE,sEAAsE;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;AAEA,4DAA4D;AAE5D;CACC,aAAa;AACd;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;AAEA;CACC,YAAY;AACb;AAEA,sEAAsE;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB;AACD;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,aAAa;AACd;AAEA;CACC,cAAc;AACf;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;AAEA;CACC;EACC,cAAc;CACf;AACD;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;AAEA,oEAAoE;AAEpE;CACC;AACD;AAEA;CACC,sBAAsB;AACvB;AAEA,2BAA2B;AAE3B,6BAA6B;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;ACvUA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACxNA,sBAAsB;AACtB;EACE,WAAW;AACb;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../utils.css';\n@import '../admin-common.css';\n@import '../../helpers.css';\n\n/** RentAll - Begin **/\n.checkBoxWidth {\n  width: 34px;\n}\n\n.textWidth {\n  width: 88%;\n  vertical-align: middle;\n  font-size: 16px;\n}\n\n.labelFontWeightNormal {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `AdminRolesForm-errorMessage-_kH0G`,
	"commonHeaderAdmin": `AdminRolesForm-commonHeaderAdmin-CXn_V`,
	"adminLayout": `AdminRolesForm-adminLayout-i3g5L`,
	"box": `AdminRolesForm-box-lgyMl`,
	"exportLink": `AdminRolesForm-exportLink-mgPgV`,
	"blockCenter": `AdminRolesForm-blockCenter-Cg83d`,
	"panelHeader": `AdminRolesForm-panelHeader-CW6U4`,
	"currencyselect": `AdminRolesForm-currencyselect-dxVJ6`,
	"mar0": `AdminRolesForm-mar0-Qm6Lq`,
	"sideAdminPageWrapper": `AdminRolesForm-sideAdminPageWrapper-AiDox`,
	"table": `AdminRolesForm-table-XywGE`,
	"tableRow": `AdminRolesForm-tableRow-OAlpN`,
	"tableCell": `AdminRolesForm-tableCell-Gu33H`,
	"formGroup": `AdminRolesForm-formGroup-tsCP8`,
	"select": `AdminRolesForm-select-mixRo`,
	"noMargin": `AdminRolesForm-noMargin-_JC8J`,
	"labelTextNew": `AdminRolesForm-labelTextNew-pahRo`,
	"displayInline": `AdminRolesForm-displayInline-sr3K2`,
	"btnUPdate": `AdminRolesForm-btnUPdate-PFAeu`,
	"btnModalDelete": `AdminRolesForm-btnModalDelete-_OZbG`,
	"radioBtn": `AdminRolesForm-radioBtn-lJOFc`,
	"backgroundImg": `AdminRolesForm-backgroundImg-e3OE3`,
	"btnWidth": `AdminRolesForm-btnWidth-MmVfa`,
	"bannerImageBg": `AdminRolesForm-bannerImageBg-ZfS80`,
	"bannerDelete": `AdminRolesForm-bannerDelete-zs2nR`,
	"modalRoot": `AdminRolesForm-modalRoot-tKQnr`,
	"modalBorderBottom": `AdminRolesForm-modalBorderBottom-Rlp2U`,
	"logInModalBody": `AdminRolesForm-logInModalBody-Q5Oqo`,
	"exportSection": `AdminRolesForm-exportSection-g6lcY`,
	"exportSectionGridSub": `AdminRolesForm-exportSectionGridSub-ZKoJO`,
	"exportText": `AdminRolesForm-exportText-aswuP`,
	"exportLinkImg": `AdminRolesForm-exportLinkImg-nQsax`,
	"vtrMiddle": `AdminRolesForm-vtrMiddle-RSYzP`,
	"exportImg": `AdminRolesForm-exportImg-ldAmh`,
	"profileViewlabel": `AdminRolesForm-profileViewlabel-PdmIQ`,
	"profileViewMainContent": `AdminRolesForm-profileViewMainContent-_zK81`,
	"profileViewMain": `AdminRolesForm-profileViewMain-f2BzD`,
	"profileViewInner": `AdminRolesForm-profileViewInner-cmtoa`,
	"profileImageSection": `AdminRolesForm-profileImageSection-dSzgt`,
	"lastviewInner": `AdminRolesForm-lastviewInner-Jxrif`,
	"whyHostHoriLine": `AdminRolesForm-whyHostHoriLine-n6Uzg`,
	"tableGrid": `AdminRolesForm-tableGrid-ydJ7f`,
	"headingContent": `AdminRolesForm-headingContent-feswr`,
	"refundTextColor": `AdminRolesForm-refundTextColor-tE6aV`,
	"dividerLine": `AdminRolesForm-dividerLine-BeDf1`,
	"smallContent": `AdminRolesForm-smallContent-nsCJz`,
	"ChangeToUpperCase": `AdminRolesForm-ChangeToUpperCase-l2brT`,
	"noBorder": `AdminRolesForm-noBorder-tCaV5`,
	"siteAdminHeading": `AdminRolesForm-siteAdminHeading-H2RVf`,
	"siteAdminSubHeading": `AdminRolesForm-siteAdminSubHeading-j4TI7`,
	"adminFormDivider": `AdminRolesForm-adminFormDivider-FqTcn`,
	"space1": `AdminRolesForm-space1-odANP`,
	"space2": `AdminRolesForm-space2-oySC9`,
	"space3": `AdminRolesForm-space3-njpai`,
	"space4": `AdminRolesForm-space4-WCBjd`,
	"space5": `AdminRolesForm-space5-Qi7w7`,
	"space6": `AdminRolesForm-space6-nRGyZ`,
	"space7": `AdminRolesForm-space7-o0NOL`,
	"spaceTop8": `AdminRolesForm-spaceTop8-WPbH7`,
	"spaceTop1": `AdminRolesForm-spaceTop1-o0z6i`,
	"spaceTop2": `AdminRolesForm-spaceTop2-Gef36`,
	"spaceTop3": `AdminRolesForm-spaceTop3-xCIpA`,
	"spaceTop4": `AdminRolesForm-spaceTop4-MueSN`,
	"spaceTop5": `AdminRolesForm-spaceTop5-aoeyp`,
	"spaceTop6": `AdminRolesForm-spaceTop6-zVrJc`,
	"spaceTop7": `AdminRolesForm-spaceTop7-Ahr9R`,
	"padding1": `AdminRolesForm-padding1-BPtvh`,
	"padding2": `AdminRolesForm-padding2-pWgKl`,
	"padding3": `AdminRolesForm-padding3-qwu6D`,
	"padding4": `AdminRolesForm-padding4-A4gyN`,
	"padding5": `AdminRolesForm-padding5-Czo9p`,
	"padding6": `AdminRolesForm-padding6-cwGag`,
	"padding7": `AdminRolesForm-padding7-gAkCf`,
	"paddingTop1": `AdminRolesForm-paddingTop1-msHCg`,
	"paddingTop2": `AdminRolesForm-paddingTop2-o_xMX`,
	"paddingTop3": `AdminRolesForm-paddingTop3-YD2Vk`,
	"paddingTop4": `AdminRolesForm-paddingTop4-QhB_1`,
	"paddingTop5": `AdminRolesForm-paddingTop5-elgGl`,
	"paddingTop6": `AdminRolesForm-paddingTop6-VPH_M`,
	"paddingTop7": `AdminRolesForm-paddingTop7-dWFzG`,
	"noPadding": `AdminRolesForm-noPadding-pupcj`,
	"textBold": `AdminRolesForm-textBold-tJvuQ`,
	"textBolder": `AdminRolesForm-textBolder-tHj06`,
	"textNormal": `AdminRolesForm-textNormal-MvpIT`,
	"spaceBottom20": `AdminRolesForm-spaceBottom20-yaWjZ`,
	"spaceBottom10": `AdminRolesForm-spaceBottom10-CuBfY`,
	"marginNone": `AdminRolesForm-marginNone-UHFAV`,
	"spaceBottom15": `AdminRolesForm-spaceBottom15-Eu48t`,
	"marginTopNone": `AdminRolesForm-marginTopNone-yGm1t`,
	"spaceTop11": `AdminRolesForm-spaceTop11-wTmon`,
	"spaceTop21": `AdminRolesForm-spaceTop21-mrO6d`,
	"spaceTop20": `AdminRolesForm-spaceTop20-L21Hw`,
	"spaceTop10": `AdminRolesForm-spaceTop10-LR0lW`,
	"textDarkBlue": `AdminRolesForm-textDarkBlue-l7Rhp`,
	"textLightBlue": `AdminRolesForm-textLightBlue-l4MYh`,
	"textLightSandleGreen": `AdminRolesForm-textLightSandleGreen-Lzojr`,
	"textLightBrown": `AdminRolesForm-textLightBrown-UEKIR`,
	"textMediumMaroon": `AdminRolesForm-textMediumMaroon-kslNL`,
	"textBrown": `AdminRolesForm-textBrown-m0AJq`,
	"textMaroon": `AdminRolesForm-textMaroon-nQMvm`,
	"textDarkBrown": `AdminRolesForm-textDarkBrown-ERPRG`,
	"textMediumBrown": `AdminRolesForm-textMediumBrown-GOLdl`,
	"textSkyBlue": `AdminRolesForm-textSkyBlue-ADv8s`,
	"textGray": `AdminRolesForm-textGray-LapmR`,
	"checkBoxWidth": `AdminRolesForm-checkBoxWidth-e425Q`,
	"textWidth": `AdminRolesForm-textWidth-nSu7O`,
	"labelFontWeightNormal": `AdminRolesForm-labelFontWeightNormal-fYSRC`
};
module.exports = ___CSS_LOADER_EXPORT___;
